import React from "react";
import {CardItem} from "./Card";
import PropTypes from "prop-types";
import {ChangeEmail} from "../../../features/change-email";

export const CustomerEmail = ({uuId, email, emailVerified, setApplication}) => {
	return emailVerified ? (
		<CardItem
			name='Էլ. հասցե'
			value={email || '-'}
		/>
	) : !!email ? (
		<ChangeEmail
			uuId={uuId}
			email={email}
			setApplication={setApplication}
		/>
	) : '-'
};

CustomerEmail.propTypes = {
	uuId: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
	emailVerified: PropTypes.bool.isRequired,
	setApplication: PropTypes.func.isRequired,
};
